var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _polygon, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobichef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 432.2 111.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  \r\n\t.st0{fill:#181817;}\r\n\t.st1{fill:#7C216F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.7 96.4v9.6c0 1.9-0.5 3.2-1.4 4.1s-2.3 1.3-4.1 1.3c-1 0-2-0.1-2.9-0.4 -0.9-0.3-1.6-0.7-2.2-1.2l0.7-1.1c0.5 0.5 1.2 0.8 1.9 1.1 0.8 0.3 1.5 0.4 2.4 0.4 1.4 0 2.4-0.3 3.1-1 0.7-0.6 1-1.6 1-3v-1.4c-0.5 0.7-1.1 1.2-1.8 1.6 -0.7 0.4-1.6 0.5-2.5 0.5 -1 0-2-0.2-2.8-0.7 -0.8-0.5-1.5-1.1-2-1.9 -0.5-0.8-0.7-1.7-0.7-2.8s0.2-1.9 0.7-2.7c0.5-0.8 1.1-1.4 2-1.9 0.8-0.4 1.8-0.7 2.8-0.7 0.9 0 1.8 0.2 2.5 0.6s1.4 0.9 1.8 1.6v-2.1H253.7zM250.2 105.1c0.6-0.3 1.1-0.8 1.5-1.4 0.4-0.6 0.5-1.3 0.5-2.1s-0.2-1.5-0.5-2.1 -0.8-1.1-1.5-1.4c-0.6-0.3-1.3-0.5-2.2-0.5 -0.8 0-1.5 0.2-2.1 0.5 -0.6 0.3-1.1 0.8-1.5 1.4 -0.4 0.6-0.5 1.3-0.5 2.1s0.2 1.5 0.5 2.1c0.4 0.6 0.8 1.1 1.5 1.4s1.3 0.5 2.1 0.5C248.9 105.6 249.6 105.4 250.2 105.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.9 97.4c0.8 0.7 1.1 1.8 1.1 3.2v6.8h-1.4v-1.7c-0.3 0.6-0.8 1-1.5 1.3 -0.6 0.3-1.4 0.5-2.3 0.5 -1.2 0-2.2-0.3-2.9-0.9 -0.7-0.6-1.1-1.4-1.1-2.3 0-0.9 0.3-1.7 1-2.2 0.7-0.6 1.7-0.9 3.2-0.9h3.5v-0.7c0-0.9-0.3-1.7-0.8-2.2 -0.5-0.5-1.3-0.7-2.3-0.7 -0.7 0-1.4 0.1-2 0.3 -0.6 0.2-1.2 0.5-1.6 0.9l-0.7-1.1c0.6-0.5 1.2-0.8 2-1.1s1.6-0.4 2.5-0.4C263.1 96.3 264.2 96.7 264.9 97.4zM263.3 105.7c0.6-0.4 1-0.9 1.3-1.7v-1.8h-3.4c-1.9 0-2.8 0.7-2.8 2 0 0.6 0.2 1.1 0.7 1.5s1.2 0.6 2 0.6C261.9 106.3 262.7 106.1 263.3 105.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.2 96.4v9.6c0 1.9-0.5 3.2-1.4 4.1s-2.3 1.3-4.1 1.3c-1 0-2-0.1-2.9-0.4 -0.9-0.3-1.6-0.7-2.2-1.2l0.7-1.1c0.5 0.5 1.2 0.8 1.9 1.1 0.8 0.3 1.5 0.4 2.4 0.4 1.4 0 2.4-0.3 3.1-1 0.7-0.6 1-1.6 1-3v-1.4c-0.5 0.7-1.1 1.2-1.8 1.6 -0.7 0.4-1.6 0.5-2.5 0.5 -1 0-2-0.2-2.8-0.7 -0.8-0.5-1.5-1.1-2-1.9 -0.5-0.8-0.7-1.7-0.7-2.8s0.2-1.9 0.7-2.7c0.5-0.8 1.1-1.4 2-1.9 0.8-0.4 1.8-0.7 2.8-0.7 0.9 0 1.8 0.2 2.5 0.6s1.4 0.9 1.8 1.6v-2.1H280.2zM276.8 105.1c0.6-0.3 1.1-0.8 1.5-1.4 0.4-0.6 0.5-1.3 0.5-2.1s-0.2-1.5-0.5-2.1 -0.8-1.1-1.5-1.4c-0.6-0.3-1.3-0.5-2.2-0.5 -0.8 0-1.5 0.2-2.1 0.5 -0.6 0.3-1.1 0.8-1.5 1.4 -0.4 0.6-0.5 1.3-0.5 2.1s0.2 1.5 0.5 2.1c0.4 0.6 0.8 1.1 1.5 1.4s1.3 0.5 2.1 0.5C275.4 105.6 276.2 105.4 276.8 105.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.2 97.5c0.8 0.8 1.2 2 1.2 3.5v6.3H293v-6.2c0-1.1-0.3-2-0.9-2.6 -0.6-0.6-1.4-0.9-2.4-0.9 -1.2 0-2.1 0.4-2.8 1 -0.7 0.7-1 1.7-1 2.9v5.7h-1.5V96.4h1.4v2c0.4-0.7 1-1.2 1.7-1.5 0.7-0.4 1.5-0.6 2.5-0.6C291.3 96.3 292.4 96.7 293.2 97.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308 102.3h-9.1c0.1 1.1 0.5 2.1 1.3 2.8s1.8 1 3 1c0.7 0 1.3-0.1 1.9-0.4 0.6-0.2 1.1-0.6 1.5-1.1l0.8 1c-0.5 0.6-1.1 1-1.8 1.3 -0.7 0.3-1.5 0.5-2.4 0.5 -1.1 0-2.1-0.2-3-0.7 -0.9-0.5-1.5-1.1-2-2 -0.5-0.8-0.7-1.8-0.7-2.9s0.2-2 0.7-2.9c0.5-0.8 1.1-1.5 1.9-2 0.8-0.5 1.7-0.7 2.7-0.7s1.9 0.2 2.7 0.7c0.8 0.5 1.4 1.1 1.9 2 0.5 0.8 0.7 1.8 0.7 2.9L308 102.3zM300.1 98.6c-0.7 0.7-1.1 1.5-1.2 2.6h7.8c-0.1-1.1-0.5-2-1.2-2.6 -0.7-0.7-1.6-1-2.7-1C301.7 97.6 300.8 97.9 300.1 98.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.7 106.1v1.2h-8.9v-1l6.9-8.7h-6.8v-1.2h8.7v1l-6.9 8.7H318.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337 91.9v15.4h-1.4v-2.2c-0.4 0.7-1 1.3-1.8 1.7 -0.7 0.4-1.5 0.6-2.5 0.6 -1 0-2-0.2-2.8-0.7 -0.8-0.5-1.5-1.1-2-2s-0.7-1.8-0.7-2.9c0-1.1 0.2-2 0.7-2.9s1.1-1.5 2-2c0.8-0.5 1.8-0.7 2.8-0.7 0.9 0 1.7 0.2 2.4 0.6 0.7 0.4 1.3 0.9 1.8 1.6v-6.6H337zM333.6 105.6c0.6-0.4 1.1-0.9 1.5-1.5 0.4-0.7 0.5-1.4 0.5-2.2 0-0.8-0.2-1.6-0.5-2.2 -0.4-0.7-0.8-1.2-1.5-1.5s-1.3-0.5-2.1-0.5c-0.8 0-1.5 0.2-2.1 0.5 -0.6 0.4-1.1 0.9-1.5 1.5 -0.4 0.7-0.5 1.4-0.5 2.2 0 0.8 0.2 1.6 0.5 2.2 0.4 0.7 0.8 1.2 1.5 1.5 0.6 0.4 1.3 0.5 2.1 0.5C332.3 106.1 333 105.9 333.6 105.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351 96.4v10.9h-1.4v-2c-0.4 0.7-0.9 1.2-1.6 1.5 -0.7 0.4-1.5 0.6-2.3 0.6 -1.4 0-2.6-0.4-3.4-1.2 -0.8-0.8-1.2-2-1.2-3.5v-6.3h1.5v6.2c0 1.2 0.3 2 0.9 2.6 0.6 0.6 1.4 0.9 2.4 0.9 1.2 0 2.1-0.4 2.7-1.1 0.7-0.7 1-1.7 1-2.9v-5.7H351z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.3 106.7c-0.3 0.2-0.6 0.4-1 0.6s-0.8 0.2-1.3 0.2c-1 0-1.8-0.3-2.4-0.8s-0.8-1.3-0.8-2.4v-6.6h-2v-1.2h2V94h1.5v2.4h3.3v1.2h-3.3v6.5c0 0.7 0.2 1.1 0.5 1.5 0.3 0.3 0.8 0.5 1.4 0.5 0.3 0 0.6 0 0.9-0.1 0.3-0.1 0.5-0.2 0.7-0.4L366.3 106.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.1 102.3H369c0.1 1.1 0.5 2.1 1.3 2.8 0.8 0.7 1.8 1 3 1 0.7 0 1.3-0.1 1.9-0.4 0.6-0.2 1.1-0.6 1.5-1.1l0.8 1c-0.5 0.6-1.1 1-1.8 1.3 -0.7 0.3-1.5 0.5-2.4 0.5 -1.1 0-2.1-0.2-3-0.7 -0.9-0.5-1.5-1.1-2-2 -0.5-0.8-0.7-1.8-0.7-2.9s0.2-2 0.7-2.9c0.5-0.8 1.1-1.5 1.9-2 0.8-0.5 1.7-0.7 2.7-0.7s1.9 0.2 2.7 0.7c0.8 0.5 1.4 1.1 1.9 2 0.5 0.8 0.7 1.8 0.7 2.9L378.1 102.3zM370.2 98.6c-0.7 0.7-1.1 1.5-1.2 2.6h7.8c-0.1-1.1-0.5-2-1.2-2.6 -0.7-0.7-1.6-1-2.7-1C371.8 97.6 370.9 97.9 370.2 98.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.1 97.5c0.8 0.8 1.2 2 1.2 3.5v6.3h-1.5v-6.2c0-1.1-0.3-2-0.8-2.6 -0.5-0.6-1.3-0.9-2.3-0.9 -1.1 0-2 0.4-2.7 1 -0.7 0.7-1 1.7-1 2.9v5.7h-1.5v-6.2c0-1.1-0.3-2-0.8-2.6 -0.5-0.6-1.3-0.9-2.3-0.9 -1.1 0-2 0.4-2.7 1 -0.7 0.7-1 1.7-1 2.9v5.7h-1.5V96.4h1.4v2c0.4-0.7 0.9-1.2 1.6-1.5s1.5-0.5 2.4-0.5c0.9 0 1.7 0.2 2.4 0.6 0.7 0.4 1.2 1 1.5 1.7 0.4-0.7 1-1.3 1.7-1.7 0.8-0.4 1.6-0.6 2.6-0.6C396.2 96.3 397.3 96.7 398.1 97.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7 97c0.8 0.5 1.5 1.1 2 2 0.5 0.8 0.7 1.8 0.7 2.9 0 1.1-0.2 2.1-0.7 2.9 -0.5 0.8-1.1 1.5-1.9 2 -0.8 0.5-1.8 0.7-2.8 0.7 -0.9 0-1.7-0.2-2.4-0.6s-1.3-0.9-1.8-1.6v6.1h-1.5v-15h1.4v2.2c0.4-0.7 1-1.3 1.8-1.7 0.7-0.4 1.5-0.6 2.5-0.6C409.9 96.3 410.8 96.5 411.7 97zM410.9 105.6c0.6-0.4 1.1-0.9 1.5-1.5 0.4-0.7 0.5-1.4 0.5-2.2 0-0.8-0.2-1.6-0.5-2.2s-0.8-1.1-1.5-1.5 -1.3-0.5-2.1-0.5c-0.8 0-1.5 0.2-2.1 0.5 -0.6 0.4-1.1 0.9-1.5 1.5s-0.5 1.4-0.5 2.2c0 0.8 0.2 1.6 0.5 2.2 0.4 0.7 0.8 1.2 1.5 1.5 0.6 0.4 1.3 0.5 2.1 0.5C409.5 106.1 410.2 105.9 410.9 105.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.7 107c-0.8-0.3-1.4-0.6-1.9-1l0.7-1.2c0.5 0.4 1 0.7 1.7 0.9s1.4 0.3 2.2 0.3c1 0 1.7-0.2 2.2-0.5 0.5-0.3 0.7-0.8 0.7-1.3 0-0.4-0.1-0.7-0.4-0.9s-0.6-0.4-1-0.5c-0.4-0.1-0.9-0.2-1.6-0.3 -0.9-0.2-1.6-0.3-2.1-0.5 -0.5-0.2-1-0.5-1.4-0.9 -0.4-0.4-0.6-1-0.6-1.7 0-0.9 0.4-1.7 1.1-2.2 0.8-0.6 1.8-0.9 3.2-0.9 0.7 0 1.4 0.1 2.1 0.3 0.7 0.2 1.3 0.4 1.7 0.7l-0.6 1.2c-0.9-0.6-2-0.9-3.2-0.9 -0.9 0-1.7 0.2-2.1 0.5s-0.7 0.8-0.7 1.3c0 0.4 0.1 0.7 0.4 1 0.3 0.2 0.6 0.4 1 0.6 0.4 0.1 1 0.2 1.7 0.4 0.9 0.2 1.6 0.3 2.1 0.5 0.5 0.2 1 0.5 1.4 0.9 0.4 0.4 0.6 1 0.6 1.7 0 1-0.4 1.7-1.2 2.3s-1.9 0.8-3.3 0.8C419.4 107.4 418.5 107.3 417.7 107z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 232.1,
    y: 95.7,
    className: "st0",
    width: 1.4,
    height: 11.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223.8,
    y: 95.7,
    className: "st0",
    width: 1.7,
    height: 11.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 215.5,
    y: 95.7,
    className: "st0",
    width: 1.9,
    height: 11.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 207.3,
    y: 95.7,
    className: "st0",
    width: 2.2,
    height: 11.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 95.7,
    className: "st0",
    width: 2.5,
    height: 11.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 190.7,
    y: 95.7,
    className: "st0",
    width: 2.7,
    height: 11.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 182.4,
    y: 95.6,
    className: "st0",
    width: 3,
    height: 11.7
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 174.2,
    y: 95.6,
    className: "st0",
    width: 3.2,
    height: 11.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 165.9,
    y: 95.6,
    className: "st0",
    width: 3.5,
    height: 11.7
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 157.6,
    y: 95.6,
    className: "st0",
    width: 3.8,
    height: 11.7
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 149.3,
    y: 95.6,
    className: "st0",
    width: 4,
    height: 11.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 141.1,
    y: 95.6,
    className: "st0",
    width: 4.3,
    height: 11.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 95.6,
    className: "st0",
    width: 4.5,
    height: 11.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 95.5,
    className: "st0",
    width: 4.8,
    height: 11.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 116.2,
    y: 95.5,
    className: "st0",
    width: 5.1,
    height: 11.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 95.5,
    className: "st0",
    width: 5.3,
    height: 11.8
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7,
    y: 95.5,
    className: "st0",
    width: 5.6,
    height: 11.8
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 91.4,
    y: 95.5,
    className: "st0",
    width: 5.9,
    height: 11.8
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 95.5,
    className: "st0",
    width: 6.1,
    height: 11.8
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9,
    y: 95.5,
    className: "st0",
    width: 6.4,
    height: 11.9
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6,
    y: 95.4,
    className: "st0",
    width: 6.6,
    height: 11.9
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3,
    y: 95.4,
    className: "st0",
    width: 6.9,
    height: 11.9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 50.1,
    y: 95.4,
    className: "st0",
    width: 7.2,
    height: 11.9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 41.8,
    y: 95.4,
    className: "st0",
    width: 7.4,
    height: 11.9
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 95.4,
    className: "st0",
    width: 7.7,
    height: 11.9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 95.4,
    className: "st0",
    width: 7.9,
    height: 11.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.1 95.3 9.1 95.3 9.1 95.3 0.4 95.3 0.4 107.3 8.7 107.3 9.1 107.3 17 107.3 17.1 107.3 25.2 107.3 25.2 95.4 17.1 95.4 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.5 23c-7.1 0-13.4 2.9-17.5 7.4C35.9 25.9 29.6 23 22.5 23 10.1 23 0 32 0 43v29.5h10V43c0-5.5 5.6-9.9 12.5-9.9S35 37.5 35 43v29.5h10V43c0-5.5 5.6-9.9 12.5-9.9C64.4 33 70 37.5 70 43v29.5h10V43C80 32 69.9 23 57.5 23z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M113.3 73.5c-13.9 0-25.3-11.3-25.3-25.3S99.4 23 113.3 23s25.3 11.3 25.3 25.3S127.2 73.5 113.3 73.5zM113.3 33c-8.4 0-15.3 6.8-15.3 15.3 0 8.4 6.8 15.3 15.3 15.3s15.3-6.8 15.3-15.3C128.6 39.9 121.7 33 113.3 33z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259 73.5c-7 0-13.7-2.6-18.7-7.3 -5.1-4.8-7.9-11.2-7.9-18 0-6.8 2.8-13.2 7.9-18 5-4.7 11.6-7.3 18.7-7.3 7 0 13.7 2.6 18.7 7.3l-6.8 7.3c-3.1-3-7.4-4.6-11.9-4.6 -4.5 0-8.7 1.6-11.9 4.6 -3.1 2.9-4.7 6.7-4.7 10.7 0 4 1.7 7.8 4.7 10.7 3.1 3 7.4 4.6 11.9 4.6 4.5 0 8.7-1.6 11.9-4.6l6.8 7.3C272.7 70.9 266 73.5 259 73.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.2 23c-5.7 0-11 1.9-15.3 5.1V0h-10v48.3c0 13.9 11.3 25.3 25.3 25.3s25.3-11.3 25.3-25.3S185.1 23 171.2 23zM171.2 63.5c-8.4 0-15.3-6.8-15.3-15.3 0-8.4 6.8-15.3 15.3-15.3 8.4 0 15.3 6.8 15.3 15.3C186.5 56.7 179.6 63.5 171.2 63.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.8 75.2l-9 4.3c-0.2-0.5-2.6-5.5-5.2-12.9 1.8-5.4 3.7-11.9 5-18.7C225.8 62.4 231.7 75 231.8 75.2zM206.6 9.8c0-5.1 4.1-9.2 9.2-9.2 5.1 0 9.2 4.1 9.2 9.2 0 5.1-4.1 9.2-9.2 9.2C210.7 19 206.6 14.9 206.6 9.8zM212.6 9.8c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2 0-1.8-1.4-3.2-3.2-3.2C214 6.6 212.6 8 212.6 9.8zM211.5 23h-15l5.4 10h8.9c-0.3 19.3-10.9 41.9-11.1 42.2l4.5 2.1 4.5 2.1c0.5-1 12-25.5 12-47.2C220.7 26.7 217 23 211.5 23z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.1 73.6c-13.9 0-25.3-11.3-25.3-25.3s11.3-25.3 25.3-25.3 25.3 11.3 25.3 25.3v5h-39.7c2.1 6 7.8 10.3 14.4 10.3 8.7 0 12.1-3 12.3-3.1l-0.1 0.1 7.2 6.9C385.8 68.1 380.2 73.6 367.1 73.6zM352.6 43.3h28.8c-2.1-6-7.8-10.3-14.4-10.3S354.7 37.4 352.6 43.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.5 23c-4.8 0-9.2 1.5-12.9 4V0h-10v72.4h10V45.9c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9v26.5h10V45.9C332.4 33.3 322.2 23 309.5 23z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.9 10h11.3V0h-11.3c-10.6 0-19.2 8.6-19.2 19.2v53.2h10V40.1h11.4v-10h-11.4V19.2C411.7 14.1 415.8 10 420.9 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobichef);
export default __webpack_public_path__ + "static/media/mobichef.febb35095f486ecfc3b7b0ce2e8041b6.svg";
export { ForwardRef as ReactComponent };